module.exports = __webpack_public_path__ + "static/media/mouthClose.9d7a663c.obj";